// V9.14 — Lottery-Only and Backoffice terminals always open full screen (kiosk-style), but
// unlike the primary cashier terminal, their users may legitimately need to step out of the
// app without closing it. These floating buttons let them minimize to the taskbar and bring
// the app back to fullscreen afterward (V10.49).
import { Minus, Square } from "lucide-react";

export function MinimizeAppButton({ show }) {
  if (!show || !window.electronAPI?.isElectron || !window.electronAPI?.minimizeWindow) return null;
  return (
    <div className="fixed top-2 right-2 z-[99999] flex items-center gap-1.5">
      <button
        type="button"
        onClick={() => window.electronAPI.maximizeWindow?.()}
        title="Maximize"
        data-testid="maximize-app-btn"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-black/30 hover:bg-black/55 text-white/80 hover:text-white transition-colors"
      >
        <Square className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        onClick={() => window.electronAPI.minimizeWindow()}
        title="Minimize"
        data-testid="minimize-app-btn"
        className="w-8 h-8 flex items-center justify-center rounded-full bg-black/30 hover:bg-black/55 text-white/80 hover:text-white transition-colors"
      >
        <Minus className="w-4 h-4" />
      </button>
    </div>
  );
}
